import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { fadeIn } from "../utils/motion"
const ProjectPage = ({ index, description }) => {
  const [selectedProject, setSelectedProject] = useState(null)
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate(-1)
    localStorage.removeItem("selectedProject")
  }
  useEffect(() => {
    // Retrieve selected project data from localStorage
    const storedProject = localStorage.getItem("selectedProject")
    if (storedProject) {
      setSelectedProject(JSON.parse(storedProject))

      // Clear stored project data from localStorage
    }
  }, [])

  // Render the selected project data
  return (
    <div>
      <div className="top-left-button " onClick={handleGoHome}>
        Go back
      </div>
      {selectedProject && (
        <div className="pt-20  px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] w-full bg-white">
          <div className="flex flex-wrap  sm:flex-nowrap mx-auto  max-w-[85vw] md:max-w-[70vw] ">
            <div className="w-full sm:w-[70%]  flex flex-col justify-center items-center pb-20">
              <div className="max-w-full sm:max-w-sm md:max-w-4xl">
                <img
                  src={selectedProject.image}
                  alt="project_image"
                  className="shadow-card"
                />
              </div>
              <div className="pt-10 max-w-full sm:max-w-sm md:max-w-4xl">
                {selectedProject.image2 && (
                  <img
                    src={selectedProject.image2}
                    alt="project_image"
                    className="shadow-card"
                  />
                )}
              </div>
              <div className="pt-10  max-w-full sm:max-w-sm md:max-w-4xl">
                {selectedProject.image3 && (
                  <img
                    src={selectedProject.image3}
                    alt="project_image"
                    className="shadow-card"
                  />
                )}
              </div>
              <div className="pt-10  max-w-full sm:max-w-sm md:max-w-4xl">
                {selectedProject.image4 && (
                  <img
                    src={selectedProject.image4}
                    alt="project_image"
                    className="shadow-card"
                  />
                )}
              </div>
            </div>
            <div className=" pt-0 md:pt-20 pb-20 text-left text-black pl-0 sm:pl-4 md:pl-10   ">
              <motion.p
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={fadeIn("left", "spring", index * 0.6, 0.85)}
                className="font-bold font-leading text-lg sm:text-xl md:text-4xl"
              >
                {selectedProject.name}
              </motion.p>
              <motion.p
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={fadeIn("left", "spring", index * 0.6, 0.85)}
                className="mt-2 text-lg font-thin "
              >
                {selectedProject.location}
              </motion.p>
              <motion.p
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={fadeIn("left", "spring", index * 0.6, 0.85)}
                className="mt-2 text-lg w-full sm:max-w-[40vw]"
              >
                {selectedProject.description}
              </motion.p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ProjectPage
